import { CTable } from './CTable.js';
import { CTableBody } from './CTableBody.js';
import { CTableCaption } from './CTableCaption.js';
import { CTableDataCell } from './CTableDataCell.js';
import { CTableFoot } from './CTableFoot.js';
import { CTableHead } from './CTableHead.js';
import { CTableHeaderCell } from './CTableHeaderCell.js';
import { CTableRow } from './CTableRow.js';

const CTablePlugin = {
    install: (app) => {
        app.component(CTable.name, CTable);
        app.component(CTableBody.name, CTableBody);
        app.component(CTableCaption.name, CTableCaption);
        app.component(CTableDataCell.name, CTableDataCell);
        app.component(CTableFoot.name, CTableFoot);
        app.component(CTableHead.name, CTableHead);
        app.component(CTableHeaderCell.name, CTableHeaderCell);
        app.component(CTableRow.name, CTableRow);
    },
};

export { CTable, CTableBody, CTableCaption, CTableDataCell, CTableFoot, CTableHead, CTableHeaderCell, CTablePlugin, CTableRow };
//# sourceMappingURL=index.js.map
